<template>
    <div class="box">


        <div class="content partcont">

            <div class="part">


                <!-- 入金2/未达标0/已结束4 -->
                <div :class="preAmountInfo.activitystatusname == '已结束' ? 'part1 parts' : 'part1'">
                    <img class="ruleimg" src="/subject/Millionsubsidy/wallent/rule.png" @click="showDialog = true"
                        alt="">
                    <div class="tops">
                        <div class="netdeposit">
                            净入金 <span>${{ walletAllinfo.mtdeposit || '--' }}</span>
                        </div>
                        <div class="topline"></div>
                        <div class="tops-cont flex2">
                            <div class="flex1">
                                <p><span class="limit">${{ wallentNums || '--' }}</span></p>
                                <p class="number">等于人民币{{ wallentNumber || '--' }}元</p>
                            </div>
                            <div class="flex1">
                                <p><span class="limit">${{ walletAllinfo.givegoldpoint || '--' }}</span></p>
                                <p class="number">美元赠金</p>
                            </div>
                        </div>
                        <div class="grade">
                            <img v-if="walletAllinfo.mtdeposit >= 300 && walletAllinfo.mtdeposit < 500"
                                src="/subject/Millionsubsidy/wallent/status1.png" alt="">
                            <img v-if="walletAllinfo.mtdeposit >= 500 && walletAllinfo.mtdeposit < 1000"
                                src="/subject/Millionsubsidy/wallent/status2.png" alt="">
                            <img v-if="walletAllinfo.mtdeposit >= 1000"
                                src="/subject/Millionsubsidy/wallent/status3.png" alt="">
                            <img v-if="walletAllinfo.mtdeposit > 0 && walletAllinfo.mtdeposit < 300 || !walletAllinfo.mtdeposit"
                                src="/subject/Millionsubsidy/wallent/status.png" alt="">

                        </div>


                    </div>
                    <div v-if="walletAllinfo.mtdeposit >= 200" class="tips" style="text-align: left;">把握最后时间</div>
                    <div class="bottoms">
                        <img src="/subject/Millionsubsidy/wallent/slider.png" alt="">
                        <div class="times timess">
                            <span class="time">{{ hours1 }}</span>
                            <span class="time">{{ minutes1 }}</span>
                            <span class="time">{{ seconds1 }}</span>
                        </div>

                    </div>
                </div>


            </div>

        </div>
        <div class="content">

            <div class="part">
                <!-- <div class="title">
                    <img src="/subject/Millionsubsidy/wallent/title.png" alt="">

                </div>
              
                <div
                    :class="(tradeStatus == '' || (tradeStatus == 1 && !qualityStatus) || (!qualityStatus1 && tradeStatus == 2)) ? 'part1 parts' : 'part1'">

                    <div class="tops">
                        <div class="tops-cont flex">
                            <div class="flex1">
                                <p><span class="limit">${{ activeInfo.depositamount || '--' }}</span></p>
                                <p class="number">—— 净入金 ——</p>
                            </div>
                            <div class="flex1">
                                <p><span class="limit">${{ activeInfo.profitloss || '--' }}</span></p>
                                <p class="number">—— 我的盈亏 ——</p>
                            </div>
                        </div>
                        <div class="grade">
                            <div v-for="(item, index) in gradeList" :key="index"
                                :class="activeIndex == index && tradeStatus != 5 ? 'active' : index != 2 ? 'active-border' : ''">

                                <img :src="item.img" class="icon" alt="">
                                <span :class="activeIndex == index ? 'active-num' : ''">
                                    <span v-if="item.lable != 0">{{
                                        '$' + item.lable + '赠金' + '+' }}</span>
                                    <span v-if="item.lables != 0">{{
                                        '$' + item.lables + '现金' }}</span></span>
                                <img v-if="tradeStatus == 3 && activeIndex == index" class="icons"
                                    src="/subject/Millionsubsidy/function/pending.png" alt="">
                                <img v-if="tradeStatus == 4 && activeIndex == index" class="icons"
                                    src="/subject/Millionsubsidy/function/finish.png" alt="">

                            </div>

                        </div>


                        <img class="boxs" v-if="(tradeStatus == '' || (tradeStatus == 1 && !qualityStatus)  )"
                            @click="toTrade" src="/subject/Millionsubsidy/function/button.png" alt="">
                        <img class="boxs" v-else-if="(!qualityStatus1 && tradeStatus == 2)"
                            src="/subject/Millionsubsidy/wallent/button.png" alt="">
                        <img class="boxs" v-else @click="toDeal" src="/subject/Millionsubsidy/wallent/todeal.png"
                            alt="">
                        <p class="tips"
                            v-if="(tradeStatus == '' || (tradeStatus == 1 && !qualityStatus) || (!qualityStatus1 && tradeStatus == 2))">
                            新户入金≥{{ minamount }}美金 方可激活7日险权益</p>

                    </div>
                    <div class="bottoms">
                        <div class="times timess">
                            <span class="time">{{ day }}</span>
                            <span class="time">{{ hour }}</span>
                            <span class="time">{{ minute }}</span>
                            <span class="time">{{ second }}</span>
                        </div>

                    </div>
                </div> -->
                <!-- 奖励明细 -->
                <div class="rewarddetail">
                    <div class="rewardtitle">奖励明细</div>
                    <ul>
                        <li v-for="(item, index) in wallentList" :key="index">
                            <span>{{ item.expireTime }} </span>
                            <span class="mun">{{ item.amount }} <span>{{ item.type == 'usd' ? '美元赠金' : item.type ==
                                    'point' ? '美元现金' : '人民币' }}</span>
                            </span>
                            <span style="text-align: right;">{{ item.status }} </span>
                        </li>
                    </ul>

                </div>

            </div>

        </div>
        <el-dialog :visible.sync="showDialog" :showClose="false" width="0px" height="50px" custom-class="loginDialogs1">
            <div class="loginDialogs1">


                <img class="closer" @click="showDialog = false" src="/subject/Millionsubsidy/wallent/close.png"
                    alt="" />
                <ul class="dialogContent" id="number">
                    <h3></h3>

                    <li>

                        <span class="tits1">注册秒领豪礼</span><br />
                        1.人民币:用户注册成功后，立即可以领取人民币红包288元，前往平台--我的钱包
                        中查看。<br />
                        2.美元赠金:注册即送588美元赠金，按照交易手数笔笔提取，前往平台--我的--赠金奖励 中查看。
                    </li>
                    <li>
                        <span class="tits1">第二阶段</span><br />
                        激活无限权益<br />
                        激活账户，根据24小时内入金层级不同获得300~900人民币不同额度的等额美元现金，详情参考下表，新客最超值推荐领取588元层级!想冲最大福利，直接选1188元层级，准没错!<br />
                        激活账户后，您的福利自动提取到交易账户进行交易使用仅需在7天内完成对应手数交易，详情参考表格。完成后，该笔资金可提取可交易，无限制。<br />
                        同时，享有入金即送等额美元赠金福利，仅限新户，充值越多，赠金越多，轻松降低交易成本，放大投资收益。
                    </li>
                    <li>
                        <span class="tits1">提醒:</span>活动7天逾期未完成要求，未提现成功，将视为自动放弃奖励权益，即该笔人民币资金会被扣回，您的其他权益不受影响。<br />
                        如果7天内，新客完成最低层级3手的要求，作为保底，288元人民币的等额美金可以正常提取。
                    </li>

                    <li>
                        <div class="tabs">
                            <table style="border-collapse:collapse;">
                                <tr class="biaoti">
                                    <th>入金区间(美金)</th>
                                    <th>现金红包(人民币)</th>
                                    <th>美元现金(等额人民币)</th>
                                    <th>总赠送额(人民币)</th>
                                    <th>7日内提现手数(手)</th>

                                </tr>
                                <tr class="biaoti">
                                    <th>100≤首入金&lt;300</th>
                                    <th>288</th>
                                    <th>0</th>
                                    <th>288</th>
                                    <th>3</th>
                                </tr>
                                <tr class="biaoti">
                                    <th>300≤首入金&lt;500</th>
                                    <th>288</th>
                                    <th>300</th>
                                    <th>588</th>
                                    <th>5</th>
                                </tr>
                                <tr class="biaoti">
                                    <th>500≤首入金&lt;1000</th>
                                    <th>288</th>
                                    <th>600</th>
                                    <th>888</th>
                                    <th>8</th>
                                </tr>
                                <tr class="biaoti">
                                    <th>1000≤首入金</th>
                                    <th>288</th>
                                    <th>900</th>
                                    <th>1188</th>
                                    <th>12</th>
                                </tr>

                            </table>
                        </div>

                    </li>
                    <!-- <li>
                        <span class="tits1">第三阶段</span><br />
                        绝对独家保障! 7日亏损全险<br />
                        新人首入后，200美金以上者，即可7天内享平台补贴，有效期内累计交易亏损达到交易补贴额度，即可获得对应现金<br />
                        1.补贴获得的美元现金和美元赠金，7日后达标自动打入账户余额。<br />
                        2.得到的现金可当真实资金使用，可交易可提现，提现时无手数要求。<br />
                        3.补贴仅能获得一次，无法重复获取。

                    </li>

                    <li>

                        <div class="tabs">
                            <table style="border-collapse:collapse;">
                                <tr class="biaoti">
                                    <th>层级</th>
                                    <th>7日累计亏损</th>
                                    <th>补贴方案</th>

                                </tr>
                                <tr>
                                    <th>L1</th>
                                    <th>≥$5,000</th>
                                    <th>$1，000美元现金+$4，000美元赠金</th>
                                </tr>
                                <tr>
                                    <th>L2</th>
                                    <th>≥$10,000</th>
                                    <th>$2，000美元现金+$8,000美元赠金</th>
                                </tr>
                               

                            </table>
                        </div>

                    </li> -->
                    <li>
                        <span class="tits1">备注说明:</span><br />

                        现金红包/人民币红包： 以人民币形式发放，用户可前往平台——我的钱包 中查看。<br />

                        人民币红包及人民币等额的美元现金，系统统一采用固定汇率7，并取整的形式来计算，并打入交易账户。<br />

                        美元现金：以美元形式发放至交易账户，可用作交易，满足提取条件后，可提取也可交易，无特殊限制。<br />

                        美元赠金：是美元形式的赠金，不可用于交易，按照交易手数笔笔提取，前往平台——我的——赠金奖励 中查看。<br />

                        为保证客户账户资金的配置，当客户获得总赠送588及以上人民币的层级，其账户强平比例调整为50%，活动结束后恢复。
                        <br />




                    </li>
                    <li>
                        <span class="tits1">注意事项：</span><br />


                        1.参加原新用户活动的客户，无法重复参加该活动;<br />

                        2.同一真实交易账户不可被多次邀请参加;<br />

                        3.交易手数的计算:本活动只针对伦敦金伦敦银交易的手数

                        计算，开仓一手再平仓一手，如此来回为一手;<br />

                        4.若判定客户交易存在异常，例如恶意套利行为、短时间内

                        如1分钟频繁进出经平台审核后实属剥头皮交易..等，公司

                        皆有权收回相应交易优惠，本公司保留随时修订、暂停、终

                        止本活动及任何相关规则条款之权利及其解释权。<br />

                    </li>
                </ul>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import userSign from '@/mixins/userSign';
import { setToken, getToken, deleteToken } from "@/utils/cookies.js";
import { appLy, sendTicket, usercenter } from '@/apis/active';
import { getConfigurationValue } from '@/apis/common'
import { getCompensate, getActicityParam, postFirstadvamtCRM } from '@/apis/transfer'
import { encryptCBC } from "@/utils/IMEI";
import { queryWalletInfo, queryWalletGrants, queryPointList,queryUserInfo } from '@/apis/user'
export default {
    mixins: [userSign],
    data() {
        return {

            scroll: "",
            timer: null,
            isApp: false,
            day: '--',
            hour: '--',
            minute: '--',
            second: '--',
            hours1: '--',
            minutes1: '--',
            seconds1: '--',
            curStartTime: '',//结束时间
            wallentTime: '',//活动时间
            userinfo: {},
            isLogin: false,//App端是否有Token
            queryInfo: {},//传递数据
            activeIndex: '',
            gradeList: [
                {
                    img: '/subject/Millionsubsidy/function/icon.png',
                    lable: '',
                    lables: ''
                },
                {
                    img: '/subject/Millionsubsidy/function/icon1.png',
                    lable: '',
                    lables: ''
                },
                {
                    img: '/subject/Millionsubsidy/function/icon2.png',
                    lable: '',
                    lables: ''
                },
            ],
            tradeStatus: '',//入金状态
            activeInfo: {},//活动信息
            minamount: '',//起赔标准
            qualityStatus: false,//是否符合标准
            qualityStatus1: false,//未达标
            walletInfo: {},//钱包信息
            preAmountInfo: '',//预赠金
            walletAllinfo: {},
            wallentInfos: {},//活动配置
            wallentNum: 0,
            wallentNums: 0,
            wallentList: [],
            showDialog: false,
            wallentNumber: 0,
            givegold: {}


        };
    },

    mounted() {

    },
    destroyed() {
        clearInterval(this.timer);
    },
    watch: {},
    created() {
        // console.log('1111111111111111', this.getDateChange(1764691199000))
        // 关闭头部导航和底部导航
        this.$emit('controlShow', true);
        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            this.queryInfo = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
            }
       
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
        
            if (token) {
                this.isLogin = true
                localStorage.setItem('account', this.$route.query.a);
                this.userKey = localStorage.getItem('token');
                this.queryUserAccount()
                

            } else {
                this.isLogin = false
                this.toLogin()
            }
        }

    },
    methods: {
        // 判断用户是否入过金
        queryUserAccount(key) {
            queryUserInfo().then(res =>{
                console.log(res)

                if (res.jfUser.isFirst == '1') {
                    this.getActivityInfo()
              
                }else{
                    this.toTrade()
                }
            })},
        renderWithdrawStatus(status) {
            let str = '';
            let color = '';
            switch (status) {
                case 0:
                    str = '待激活';
                    color = '#ed161b';
                    break;
                case 1:
                    str = '已发放';
                    color = '#ed161b';
                    break;
                case 2:
                    str = '已过期';
                    color = '#999';
                    break;
                case 3:
                    str = '可提取';
                    color = '#16c780';
                    break;
                case 4:
                    str = '待审核';
                    color = '#f9a333';
                    break;
                case 5:
                    str = '待入账';
                    color = '#999';
                    break;
                case 6:
                    str = '审核未通过';
                    color = '#ed161b';
                    break;
                case 7:
                    str = '已提取';
                    color = '#bbb';
                    break;
                case 8:
                    str = '已扣回';
                    color = '#bbb';
                    break;
                case 9:
                    str = '已领取';
                    color = '#16c780';
                    break;
            }
            return str
        },
        // 钱包
        getwallent() {
            const params = {
                page: 1,
                size: 9999,
                status: '',
                grantsType: '1',
                endTime: new Date(new Date().setHours(23, 59, 59, 999)).getTime() ,
               
                startTime: new Date(new Date().setDate(new Date().getDate() - 120)).setHours(0, 0, 0, 0) 
            }
            queryWalletGrants(params).then(res => {
              
                this.wallentList = res.records || []
                if (this.wallentList.length > 0) {
                    
                        this.wallentList.forEach(item => {
                            item.expireTime = this.getDateChange(item.sendTime)
                            item.status = this.renderWithdrawStatus(item.status)
                        })
                        if (this.wallentInfos.level && Number(this.wallentNumber) > 288) {
                        this.wallentList.push({
                            expireTime: this.getDateChange(this.walletAllinfo.firstdeposittimeend + 8 * 60 * 60 * 1000),
                            status: this.preAmountInfo.mt4advancegivegoldstatusname,
                            amount: this.wallentNumber - 288,
                        })
                    

                    }

                } else {
                   
                }
               
                this.getPoint()

            })
        },
        // 首入
        getwalletInfo(data) {
            const params = {
                accountid: localStorage.getItem('account'),
                activityid: data,
                platform: 1
            }
            postFirstadvamtCRM('firstJoinActivityInfo', params).then(res => {
            
                this.walletAllinfo = res.content.accountinfo || {}
                this.wallentInfos = res.content.activitycfg
                this.wallentTime = this.walletAllinfo.firstdeposittimeend
          
                this.updateCountdown()
                setInterval(this.updateCountdown, 1000);
               
                // if (this.wallentInfos.level && Number(this.wallentNumber)> 288){
                //     this.wallentList.push({
                //         expireTime: this.getDateChange(this.walletAllinfo.firstdeposittimeend + 8 * 60 * 60 * 1000),
                //         status: this.preAmountInfo.mt4advancegivegoldstatusname,
                //         amount: this.wallentNumber - 288,
                //     })
                // }
               
                this.getwallent()

            })
        },
        // 赠金点明细
        getPoint() {
            const params = {
                pageNo: 1,
                pageSize: 9999,
            }
            queryPointList(params).then(res => {
            
                const list = res.list
                if (list && list.length > 0) {
                    // if (this.tradeStatus == 4 && this.givegold.givegoldpoint>0){
                    //     this.wallentList.push({
                    //         expireTime: '---- -- -- -- -- -----------',
                    //         status: '已发放',
                    //         amount: this.givegold.givegoldpoint,
                    //         type: 'point'

                    //     })
                    // }
                    
                    list.forEach(item => {

                        if (item.eventId == 6 && (item.source.includes('首充') || item.source.includes('7日险'))) {
                            this.wallentList.push({
                                expireTime: item.startDate,
                                status: '已发放',
                                amount: item.amount,
                                type: 'usd'
                            })
                        }
                    })
                }

            })
        },
        // 首充预增
        getActivityInfo() {
            const iv = 'LIQABxPFN04DhnkX';
            const params = {
                accountid: localStorage.getItem('account'),

            }
            getActicityParam('findbyaccountid', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
               
                let list = res.activityuserinfos
                if (list && list.length > 0) {
                    const join = list.filter(item => item.code === 'AdvAmt');
                   
                    if (join.length > 0) {
                        this.getwalletInfo(join[0].activityid)
                        this.preAmountInfo = join[0] || ''

                        this.wallentNumber = join[0].firstchargegroup == 'A1' ? 588 : join[0].firstchargegroup == 'A2' ? 888 : join[0].firstchargegroup == 'A3' ? 1188 : 288

                        this.wallentNums = Math.floor(this.wallentNumber / 7)

                    }else{

                    }

                } else {
               

                }
            })
        },
        // 亏损赔付
        getActiveinfo() {
            let params = {
                accountid: localStorage.getItem('account'),
                platform: 1
            }
            const iv = 'LIQABxPFN04DhnkX';
            getCompensate('paidUrl', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
            
                if (res.status == 0) {
                    let data = res.content.accountInfo
                    this.givegold = data
                    let datas = res.content.activityCfg
                    this.activeInfo = data
                    this.activeInfo.rule = this.activeInfo.rule.replace(/img/gi, 'img style="width: 100%"')
                    this.activeInfo.rule = this.activeInfo.rule.replace(
                        /<span\s+style\s*=\s*(["'])[^"']*text-wrap-mode\s*:\s*nowrap;?[^"']*\1\s*>/gi,
                        `<span style="white-space: wrap;">`
                    )
                    this.minamount = res.content.minamount ? res.content.minamount : ''
                    let level = data.level
                    let status = data.status
               
                    this.activeIndex = level ? level == 'A1' ? 0 : level == 'A2' ? 1 : level == 'A3' ? 2 : 4 : 4
                    // 结束时间保障用expirationtime,其余用depositstarttime
                    this.curStartTime = data.expirationtime

                    // （1：未到期，2：未达标，3：待赔付，4：已赔付，5：已作废）
                    // 如果未到期且时间到了净入金小于赔付标准时间--如果大于前往入金总入金
                    if (status == 1) {
                        // 
                        const today = new Date()
                        const endOfMonth = new Date(data.depositendtime + 8 * 3600000).getTime();
                       
                        if ((endOfMonth - today < 0)) {
                            this.curStartTime = data.expirationtime
                            this.qualityStatus = true
                            this.updateCountdown1()
                            setInterval(this.updateCountdown1, 1000);
                        } else {
                            this.curStartTime = data.depositendtime

                            this.qualityStatus = false
                        }

                    }
                    // 如果状态为2且时间到了；
                    if (status == 2) {
                        // 如果净入金大于赔付标准时间
                        if (data.depositamount > this.minamount) {
                            this.qualityStatus1 = true
                        } else {
                            this.qualityStatus1 = false
                        }

                    }
                    this.tradeStatus = status ? status : ''
                    this.gradeList = [];
                    const imgArray = ['/subject/Millionsubsidy/function/icon.png', '/subject/Millionsubsidy/function/icon1.png', '/subject/Millionsubsidy/function/icon2.png'];
                    datas.forEach((item, index) => {
                        this.gradeList.push({
                            img: imgArray[index] || '/subject/Millionsubsidy/function/icon.png',
                            lable: item.givegoldpoint ? item.givegoldpoint : 0,
                            lables: item.amount ? item.amount : 0
                        });
                    });
                    
                    // 不为空（未参加）未达标状态为1；
                    if ((this.qualityStatus1 && this.tradeStatus == 2) || (this.tradeStatus != '' && !this.qualityStatus1 && !this.qualityStatus && this.tradeStatus != 2)) {
                        this.updateCountdown1()
                        setInterval(this.updateCountdown1, 1000);
                    }


                } else {

                    this.$message({
                        message: res.message,
                        type: 'warning',
                    });
                }
            })
        },
        async getTradeWapLink() {

            try {
                const res = await getConfigurationValue({ key: 'H5LinkMT5' });
                const defaultLink = 'https://h5pro.rlc561.com';
                if (res) {
                    return res
                } else {
                    return defaultLink
                }
            } catch (e) {
                return defaultLink
            }
        },
        // app登录
        toLogin() {
            // 在安卓app
            if (window.android) {
                window.android.gotoLogin();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoLogin()
                return
            }
            if (window.ReactNativeWebView) {
                const message = JSON.stringify({ method: 'gotoLogin', data: '' });
                window.ReactNativeWebView.postMessage(message);
                return
            }
        },
        // 去入金
        async toTrade() {
            // 在安卓app
            if (window.android) {
                window.android.gotoDeposit();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoDeposit()
                return
            }
          
            window.location.href = this.queryInfo.fromUrl + '/assets/deposit';
        },
        // 去交易
        async toDeal() {
            // 在安卓app
            if (window.android) {
                window.android.gotoTrade();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoTrade.postMessage('1');
                return
            }
            if (window.ReactNativeWebView) {
                const message = JSON.stringify({ method: 'gotoTrade', data: '' });
                window.ReactNativeWebView.postMessage(message);
                return
            }
            // 在网页浏览器
            // const h5LinkUrl = await this.getTradeWapLink();
            // const sendData = {
            //     token: getToken(),
            //     userStatus: 3,
            // }
            window.open(this.queryInfo.fromUrl + '/home/quote');

        },

        // 倒计时
        updateCountdown() {
            // const today = new Date();

            const today = new Date()

            const endOfMonth = new Date(this.wallentTime + 8 * 3600000).getTime();

            let timeLeft = endOfMonth - today;
            if (timeLeft <= 0) {
                timeLeft = 0;
                clearInterval(this.timer);
            }

            this.hours1 = String(
                Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            ).padStart(2, "0");
            this.minutes1 = String(
                Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
            ).padStart(2, "0");
            this.seconds1 = String(
                Math.floor((timeLeft % (1000 * 60)) / 1000)
            ).padStart(2, "0");



        },
        updateCountdown1() {
            // const today = new Date();

            const today = new Date()

            const endOfMonth = new Date(this.curStartTime + 8 * 3600000).getTime();

            let timeLeft = endOfMonth - today;
            if (timeLeft <= 0) {
                timeLeft = 0;
                clearInterval(this.timer);
            }

            this.day = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(
                2,
                "0"
            );
            this.hour = String(
                Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            ).padStart(2, "0");
            this.minute = String(
                Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
            ).padStart(2, "0");
            this.second = String(
                Math.floor((timeLeft % (1000 * 60)) / 1000)
            ).padStart(2, "0");


        },



        // 计算时间差值
        constdiffInDays(date1, date2) {


            const data2 = new Date().getTime()
            const data1 = new Date(date1 + 8 * 3600000).getTime();
         
            let data = (data2 - data1)
            return Math.floor(data / (24 * 3600 * 1000))


        },
        // 时间戳转时间
        getDateChange(date) {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要+1
            const day = String(d.getDate()).padStart(2, '0'); // 日小于10时前面加0
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            const seconds = String(d.getSeconds()).padStart(2, '0');

            // 返回格式为：年-月-日 时:分:秒
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

    },


};
</script>

<style lang="less" scoped>
.box {
    width: 20%;
    margin: 0 auto;



    .tps {
        position: absolute;
        top: 81%;
        left: 24%;
    }

    .times {

        padding: 10px 20px 20px 00px;
        box-sizing: border-box;
        height: auto;
        width: 89%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            line-height: 43px;
            font-size: 12px;
            font-weight: 700;
            color: #f54937;
            // margin-right: 12px;

        }

        .time {
            font-size: 30px;
            display: flex;
            align-items: baseline;
        }


    }





    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;

        background: url(/subject/Millionsubsidy/function/bg.png) no-repeat;
        background-size: 100% 100%;



        .part {
            // max-width: 1400px;
            width: 94%;
            margin: 0 auto;
            padding: 4% 2% 10%;

            .title {
                width: 50%;
                height: auto;
                text-align: center;
                margin: 0 auto;
                margin-bottom: -10px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .part1 {
                box-sizing: border-box;


                padding: 10% 4% 10%;

                background: url(/subject/Millionsubsidy/function/aliderbg.png) no-repeat center center;
                background-size: 100% 100%;
                margin: 0 auto;
                display: block;
                position: relative;



                .flex {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .flex1 {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }

                .flex2 {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .tops {
                    padding: 20px 0 80px;

                    &-cont {


                        div {
                            width: 136px;
                            height: 71px;




                            p {
                                font-size: 12px;

                                color: #ff270a;
                            }

                            .limit {
                                font-size: 32px;
                                font-weight: 600;

                            }

                            .number {
                                color: #7f2815;
                                font-weight: 500;
                            }
                        }

                    }

                    .grade {
                        background: #fff;
                        display: flex;
                        flex-direction: column;
                        margin-top: 50px;

                        div {
                            display: flex;
                            align-items: center;

                            padding: 4px 0 4px 30px;

                            .icon {
                                width: 36px;
                                height: 40px;
                                margin-right: 10px;
                            }

                            .icons {
                                width: 60px;
                                height: auto;
                                margin-left: 30px;
                            }

                            font-size: 16px;
                            color: #000;
                            font-weight: 600;
                        }

                        .active-border {
                            border-bottom: 1px solid #ccc;
                        }

                        .active {
                            background: url(/subject/Millionsubsidy/function/bg1.png) no-repeat center;
                            background-size: 100% 100%;
                            border-radius: 10px;
                        }

                        .active-num {
                            // color: #fffcab;
                        }
                    }



                    .boxs {
                        width: 100%;
                        margin-top: 20px;
                    }
                }

                .bottoms {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                    padding-top: 20px;

                    .tit {
                        color: #FE5905;
                        font-size: 16px;
                        font-weight: 600;
                        position: absolute;
                        top: -70%;
                        left: 30%;
                    }

                    .tits {
                        font-size: 13px;
                        color: #FF8314;
                        position: absolute;
                        top: -20%;
                        left: 20%;

                    }

                    img {
                        width: 100%;
                    }
                }

            }

            .parts {
                background: url(/subject/Millionsubsidy/function/qualified.png) no-repeat center center;
                background-size: 100% 100%;
            }

            .tips {
                color: #fff;
                font-size: 14px;
                font-weight: 600;
                margin: 0;
                text-align: center;
            }

            .rewarddetail {
                background: url(/subject/Millionsubsidy/wallent/bg2.png) no-repeat center center;
                background-size: 100% 100%;
                width: 100%;
                height: 287px;
                padding-top: 20%;
                box-sizing: border-box;
                position: relative;
                margin-top: 20px;

                .rewardtitle {
                    background: #ff8b1a;
                    width: 90px;
                    height: 44px;
                    border-radius: 0 0 10px 10px;
                    color: #fff;
                    font-size: 16px;
                    font-weight: 600;
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);

                    text-align: center;
                    line-height: 44px;
                }

                ul {
                    display: flex;
                    flex-direction: column;
                    height: 210px;
                    overflow-y: auto;

                    li {
                        width: 90%;
                        margin: 0 auto;
                        padding-bottom: 10px;
                        font-size: 14px;
                        color: #999;

                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        border-bottom: 1px solid #ccc;
                    }

                    .mun {}
                }
                                ul::-webkit-scrollbar {
                                    display: none;
                                }
            }

            .wappart2 {

                display: block;
                margin: 0 auto;
                margin-top: 30px;
                padding: 1% 6% 10%;
                background: url(/subject/Millionsubsidy/function/bg2.png) no-repeat center;
                background-size: 100% 100%;
                background-position: center;
                box-sizing: border-box;

                /* 填充整个小div */
                .clearfix::after {
                    content: "";
                    display: table;
                    clear: both;
                }

                h3 {
                    color: #d88f4f;
                    text-align: center;
                    font-size: 12px;
                }

                li {
                    font-size: 12px;
                    color: #000;
                    font-weight: 500;
                    line-height: 34px;

                    span {
                        font-weight: 600;
                        color: #ff4f10;
                    }

                    .example {
                        color: #1665f5;
                        font-weight: 600;
                    }

                    .font {
                        color: #000;
                        font-weight: 600;
                    }

                    img {
                        width: 100%;
                        height: auto;
                        margin: 20px 0;
                    }

                    table {
                        margin: 20px 0;
                        width: 100%;
                        border: 1px solid #464646;
                        border-radius: 10px;

                        tr {
                            th {
                                text-align: center;
                                font-weight: 500;
                                line-height: 24px;
                                border-bottom: 1px solid #464646;
                                border-right: 1px solid #464646;
                                padding: 5px;
                            }

                            th:last-child {}
                        }

                        tr:nth-child(1) {
                            th {
                                font-weight: 600;
                            }
                        }
                    }
                }





            }


        }

    }

    .partcont {
        padding-top: 40px;

        .part {
            background: url(/subject/Millionsubsidy/wallent/bg.png) no-repeat center center;
            background-size: 100% 100%;
            padding: 4% 2%;
            width: 94%;
            box-sizing: border-box;

            .part1 {
                background: none;
                padding: 4% 2% 0%;
                position: relative;

                .ruleimg {
                    position: absolute;
                    top: 4%;
                    right: 0;
                    width: 44px;
                    height: auto;
                    cursor: pointer;
                }

                .topline {
                    height: 4px;
                    border-radius: 4px;
                    width: 80%;
                    margin: 0 auto;

                    background: linear-gradient(90deg, #fff6ec 0%, #ffe4af 100%);
                }

                .tops {
                    padding: 20px 0;

                    .netdeposit {
                        margin-bottom: 10px;
                    }

                    .grade {
                        background: none;
                        margin-top: 20px;
                    }

                    .netdeposit {
                        text-align: center;
                        font-weight: 600;
                        font-size: 22px;
                        color: #000;

                        span {
                            color: #ff0619;
                            font-size: 32px;
                        }
                    }

                    &-cont {
                        margin-top: 14px;
                        padding-bottom: 20px;

                        div {
                            width: 48%;
                            height: 75px;
                            background: url(/subject/Millionsubsidy/wallent/bg1.png) no-repeat center center;
                            background-size: 100% 100%;

                            p {
                                margin: 0;
                            }

                            .number {
                                color: #fff;
                                padding: 2px 6px;
                                border-radius: 10px;
                                background: linear-gradient(90deg, #ec0605 0%, #fc6346 100%);
                            }
                        }
                    }
                }

                .bottoms {
                    padding-top: 0;

                    .times {
                        width: 64%;
                        position: absolute;
                        top: 45%;


                    }
                }
            }

        }
    }

    .loginDialogs1 {
        .closer {
            position: absolute;
            top: 0px;
            right: 8%;
            width: 20px;
            height: 20px;
        }

        position: relative;
        position: fixed;
        top: 50%;
        left: 50.5%;
        transform: translate(-50%, -50%);
        width:400px;
        height: 800px;
        overflow-y: auto;

        .dialogContent {
            box-sizing: border-box;
            padding: 2% 20px 4%;

            overflow-y: scroll;
            width: 90%;
            height: 880px;
            background: url(/subject/Millionsubsidy/function/bg2.png) no-repeat center center;
            background-size: 100% 100%;
            margin-top: 20px;
            font-size: 14px;
            .tits1{
                font-weight: 600;
                color: #000;
            }
            h3 {
                color: #d88f4f;
                text-align: center;

            }

            li {
                font-size: 16px;
                color: #464646;
                line-height: 34px;

                span {
                    font-weight: 600;
                    color: #ff7e50;
                }

                .example {
                    color: #1665f5;
                    font-weight: 600;
                }

                .font {
                    color: #000;
                    font-weight: 600;
                }

                img {
                    width: 100%;
                    height: auto;
                    margin: 20px 0;
                }

                table {
                    margin: 20px 0;
                    width: 100%;
                    border: 1px solid #464646;
                    border-radius: 10px;
                    font-size: 14px;

                    tr {
                        th {
                            text-align: center;
                            font-size: 14px;
                            font-weight: 500;
                            line-height: 24px;
                            border-bottom: 1px solid #464646;
                            border-right: 1px solid #464646;
                            padding: 5px;
                        }

                        th:last-child {}
                    }

                    tr:nth-child(1) {
                        th {
                            font-weight: 600;
                        }
                    }
                }
            }
        }

        &::-webkit-scrollbar {
            width: 0px;
        }

        .dialogContent::-webkit-scrollbar {
            display: none;
        }
    }


}




@media screen and (max-width: 500px) {
    .box {
        width: 100%;

        .banner {
            width: 100%;


            // padding-top: 75px;
        }





        .times {

            padding: 10px 20px 20px 00px;
            box-sizing: border-box;
            height: auto;
            width: 89%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                line-height: 43px;
                font-size: 12px;
                font-weight: 700;
                color: #f54937;
                // margin-right: 12px;

            }

            .time {
                font-size: 30px;
                display: flex;
                align-items: baseline;
            }


        }





        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;

            background: url(/subject/Millionsubsidy/function/bg.png) no-repeat;
            background-size: 100% 100%;



            .part {
                // max-width: 1400px;
                width: 94%;
                margin: 0 auto;
                padding: 4% 2% 10%;

                .part1 {
                    box-sizing: border-box;


                    padding: 10% 4% 10%;

                    background: url(/subject/Millionsubsidy/function/aliderbg.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    display: block;
                    position: relative;



                    .flex {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .flex1 {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }

                    .tops {
                        padding: 20px 0 80px;

                        &-cont {


                            div {
                                width: 136px;
                                height: 71px;




                                p {
                                    font-size: 12px;

                                    color: #ff270a;
                                }

                                .limit {
                                    font-size: 32px;
                                    font-weight: 600;

                                }

                                .number {
                                    color: #7f2815;
                                    font-weight: 500;
                                }
                            }

                        }

                        .grade {
                            background: #fff;
                            display: flex;
                            flex-direction: column;
                            margin-top: 50px;

                            div {
                                display: flex;
                                align-items: center;

                                padding: 4px 0 4px 30px;

                                .icon {
                                    width: 36px;
                                    height: 40px;
                                    margin-right: 10px;
                                }

                                .icons {
                                    width: 60px;
                                    height: auto;
                                    margin-left: 30px;
                                }

                                font-size: 16px;
                                color: #000;
                                font-weight: 600;
                            }

                            .active-border {
                                border-bottom: 1px solid #ccc;
                            }

                            .active {
                                background: url(/subject/Millionsubsidy/function/bg1.png) no-repeat center;
                                background-size: 100% 100%;
                                border-radius: 10px;
                            }

                            .active-num {
                                // color: #fffcab;
                            }
                        }



                        .boxs {
                            width: 100%;
                            margin-top: 20px;
                        }
                    }

                    .bottoms {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: relative;
                        padding-top: 20px;

                        .tit {
                            color: #FE5905;
                            font-size: 16px;
                            font-weight: 600;
                            position: absolute;
                            top: -70%;
                            left: 30%;
                        }

                        .tits {
                            font-size: 13px;
                            color: #FF8314;
                            position: absolute;
                            top: -20%;
                            left: 20%;

                        }

                        img {
                            width: 100%;
                        }
                    }

                }

                .parts {
                    background: url(/subject/Millionsubsidy/function/qualified.png) no-repeat center center;
                    background-size: 100% 100%;
                }

                .tips {
                    color: #fff;
                    font-size: 14px;
                    font-weight: 600;
                    margin: 0;
                    text-align: center;
                }



                .wappart2 {

                    display: block;
                    margin: 0 auto;
                    margin-top: 30px;
                    padding: 1% 6% 10%;
                    background: url(/subject/Millionsubsidy/function/bg2.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;

                    /* 填充整个小div */
                    .clearfix::after {
                        content: "";
                        display: table;
                        clear: both;
                    }

                    h3 {
                        color: #d88f4f;
                        text-align: center;
                        font-size: 12px;
                    }

                    li {
                        font-size: 12px;
                        color: #000;
                        font-weight: 500;
                        line-height: 34px;

                        span {
                            font-weight: 600;
                            color: #ff4f10;
                        }

                        .example {
                            color: #1665f5;
                            font-weight: 600;
                        }

                        .font {
                            color: #000;
                            font-weight: 600;
                        }

                        img {
                            width: 100%;
                            height: auto;
                            margin: 20px 0;
                        }

                        table {
                            margin: 20px 0;
                            width: 100%;
                            border: 1px solid #464646;
                            border-radius: 10px;

                            tr {
                                th {
                                    text-align: center;
                                    font-weight: 500;
                                    line-height: 24px;
                                    border-bottom: 1px solid #464646;
                                    border-right: 1px solid #464646;
                                    padding: 5px;
                                }

                                th:last-child {}
                            }

                            tr:nth-child(1) {
                                th {
                                    font-weight: 600;
                                }
                            }
                        }
                    }





                }


            }
        }

        .partcont {
            padding-top: 40px;

            .part {
                background: url(/subject/Millionsubsidy/wallent/bg.png) no-repeat center center;
                background-size: 100% 100%;
                padding: 4% 2%;
                width: 94%;
                box-sizing: border-box;

                .part1 {
                    background: none;
                    padding: 4% 2% 0%;
                    position: relative;

                    .ruleimg {
                        position: absolute;
                        top: 4%;
                        right: 0;
                        width: 44px;
                        height: auto;
                        cursor: pointer;
                    }

                    .topline {
                        height: 4px;
                        border-radius: 4px;
                        width: 80%;
                        margin: 0 auto;

                        background: linear-gradient(90deg, #fff6ec 0%, #ffe4af 100%);
                    }

                    .tops {
                        padding: 20px 0;

                        .netdeposit {
                            margin-bottom: 10px;
                        }

                        .grade {
                            background: none;
                            margin-top: 20px;
                        }

                        .netdeposit {
                            text-align: center;
                            font-weight: 600;
                            font-size: 22px;
                            color: #000;

                            span {
                                color: #ff0619;
                                font-size: 32px;
                            }
                        }

                        &-cont {
                            margin-top: 14px;
                            padding-bottom: 20px;

                            div {
                                width: 48%;
                                height: 75px;
                                background: url(/subject/Millionsubsidy/wallent/bg1.png) no-repeat center center;
                                background-size: 100% 100%;

                                p {
                                    margin: 0;
                                }

                                .number {
                                    color: #fff;
                                    padding: 2px 6px;
                                    border-radius: 10px;
                                    background: linear-gradient(90deg, #ec0605 0%, #fc6346 100%);
                                }
                            }
                        }
                    }

                    .bottoms {
                        padding-top: 0;

                        .times {
                            width: 64%;
                            position: absolute;
                            top: 45%;


                        }
                    }
                }

            }
        }
                .loginDialogs1{
                    position: fixed;
                  
                    left: 55%;
            .closer {
                    position: absolute;
                    top: 12%;
                    right: 10%;
                    width: 20px;
                    height: 20px;
                }
                    .dialogContent {
                        width: 90%;
                        height: 550px;
                        margin-top: 30%;
                        position: relative;
                        
                    }
                }

    }

}
</style>
